import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';

const LeaveWarningIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 64 64" sx={{ width: '64px', height: '64px', ...sx }} {...props}>
      <g clipPath="url(#clip0_6121_15649)">
        <path
          d="M54.9204 60.7536H9.07847C5.93237 60.7536 3.00998 59.1247 1.35609 56.448C-0.298287 53.7717 -0.448729 50.4298 0.958493 47.6153L23.8795 8.37282C25.4176 5.29754 28.5608 3.35449 31.9994 3.35449C35.4381 3.35449 38.5813 5.29754 40.1194 8.37282L63.0404 47.6153C64.4476 50.4298 64.2972 53.7717 62.6428 56.448C60.9889 59.1247 58.067 60.7536 54.9204 60.7536Z"
          fill="#F0C419"
        />
        <path
          d="M54.9259 60.7536H31.9995V3.35442C35.4465 3.33293 38.6024 5.2838 40.1239 8.37715L63.039 47.6182C64.4482 50.4307 64.2997 53.7726 62.6468 56.4489C60.9934 59.1256 58.072 60.7545 54.9259 60.7536Z"
          fill="#F29C1F"
        />
        <path
          d="M36.4147 50.8189C36.4147 53.2577 34.4374 55.2345 31.9991 55.2345C29.5607 55.2345 27.584 53.2577 27.584 50.8189C27.584 48.3806 29.5607 46.4038 31.9991 46.4038C34.4374 46.4038 36.4147 48.3806 36.4147 50.8189Z"
          fill="#35495E"
        />
        <path
          d="M36.4151 50.8189C36.4151 51.9902 35.9501 53.1131 35.1222 53.9416C34.2938 54.7695 33.1708 55.2345 31.9995 55.2345V46.4038C33.1708 46.4033 34.2938 46.8683 35.1222 47.6967C35.9501 48.5247 36.4151 49.6481 36.4151 50.8189Z"
          fill="#2C3549"
          fillOpacity="0.368627"
        />
        <path
          d="M31.9991 12.1851C34.4374 12.1851 36.4147 14.1618 36.4147 16.6006V37.5732C36.4147 40.0115 34.4374 41.9883 31.9991 41.9883C29.5607 41.9883 27.584 40.0115 27.584 37.5732V16.6006C27.584 14.1618 29.5607 12.1851 31.9991 12.1851Z"
          fill="#35495E"
        />
        <path
          d="M36.4151 16.6006V37.5732C36.4151 38.7445 35.9501 39.8674 35.1222 40.6954C34.2938 41.5238 33.1708 41.9888 31.9995 41.9883V12.1851C33.1708 12.1836 34.2952 12.6481 35.1236 13.4765C35.9516 14.3049 36.4166 15.4289 36.4151 16.6006Z"
          fill="#35495E"
        />
      </g>
      <defs>
        <clipPath id="clip0_6121_15649">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default LeaveWarningIcon;
